import React from 'react';
import { BlogPost } from '@/lib/blogData';
import BlogCard from '@/components/blog/BlogCard';

export const FeaturedPost: React.FC<{ post: BlogPost }> = ({ post }) => {
    return (
        <div className="mb-16 md:mb-24">
            <BlogCard 
                {...post} 
                featured={true}
            />
        </div>
    );
};
